import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

export interface LinkedInStatus {
  connected: boolean;
  name?: string;
  avatar?: string | null;
  expiresAt?: string;
  expiresInDays?: number;
  expired?: boolean;
}

export const useLinkedInStatus = () =>
  useQuery<LinkedInStatus>({
    queryKey: ["linkedin", "status"],
    queryFn: () => api.linkedin.status(),
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
  });
